module.exports = __webpack_public_path__ + "img/newton.1ea5a8fd.png";